export default {
	valor_servico: {
		label: 'Valor do serviço',
		validation: { required: true },
		size: 'xs12',
		money: true
	}
};
